(function(){

  /**
   * Configure customizations for specific acadmic mappings.
   *
   * Note that additional customizations are implemented in
   *
   * * academic-mapping-string-customer.service.js
   * * domain-text.filter.js
   */
  angular.module('edxComponents')
    .factory('edxCreateAstAssignmentConfigurationService', [edxCreateAstAssignmentConfigurationServiceFactory]);

  function edxCreateAstAssignmentConfigurationServiceFactory() {
    /*
    Return a map from Academic Mapping name to configuration for the customizations

    Available customizations:

    hideDomainsList - When true, the drop down for selecting the Domain focus type on the create assignment page is
    hidden, if there are less than 2 items to display.  After a Level selection is made, if there is only 1 Domain
    optional available then it is automatically selected internally.

    hideStandardsList - When true, the drop down for selecting the Standard and Cluster focus types is hidden.  In
    contrast to hideDomainsList, the drop down is always hidden regardless of the number of items.  After a Domain
    selection is made, the first available Standard option is automatically selected.
     */
    return {
      cflm: {
        hideDomainsList: true
      },
      cflm_2021: {
        hideDomainsList: true
      },
      gomath: {
        hideStandardsList: true
      },
      everydaymath_4th: {
        hideStandardsList: true
      },
      everydaymath_3rd: {
        hideStandardsList: true
      },
      illustrative_math: {
        hideStandardsList: true
      },
      reveal_math: {
        hideStandardsList: true
      },
      amplify_desmos : {
        hideStandardsList: true
      }
    };
  }
})();
